import React from 'react'
import PropTypes from 'prop-types'
import Drawer from '@material-ui/core/Drawer'

const DrawerAdapter = ({
  children, className, side, type,
}) => (
  <Drawer
    className={className}
    anchor={side}
    variant={type}
  >
    { children }
  </Drawer>
)

DrawerAdapter.propTypes = {
  side: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default DrawerAdapter
